import React ,{useState}from 'react'
import { BsPersonCircle } from "react-icons/bs";
import { MdOutlineAlternateEmail } from "react-icons/md";
import { FaPhoneSquareAlt } from "react-icons/fa";
import { FaPercent } from "react-icons/fa";
import { FaMoneyBill } from "react-icons/fa6";
import { FaCalendarDay } from "react-icons/fa";
import { IoIosTime } from "react-icons/io";
import { IoIosPricetag } from "react-icons/io"
import { SiNamecheap } from "react-icons/si";
import { MobileDatePicker } from '@mui/x-date-pickers';
import sedanImage from "../img/car1.jpg";
import moment from 'moment';
import { useSelector } from 'react-redux';
import Alert_Modals from '../components/Alert_Modals';
import SimpleBackdrop from '../components/SimpleBackdrop';
import api from '../api/api';
import { useNavigate } from 'react-router-dom';
export const nf=new Intl.NumberFormat('en-Us',{
    style:'currency',
    currency:'ETB',
    minimumFractionDigits:2,
    maximumFractionDigits:2
});

function Bookingpage() {
    const selected_car =useSelector((state)=>state.user.selected_car);
    const [account,setAccount]=useState(JSON.parse(localStorage.getItem('account'))||null);
    const showModal= Alert_Modals();
    const navigate= useNavigate();
    const [loading,setLoading]=useState(false);
    const [formData,setForm]=useState({
        name:account.fullName.split(" ")[0],
        email:account.email,
        Phonenumber:account.phone,
        driver:"withDriver",
        userType:account.userType,
        startDate:moment.now(),
        durationDays:1,
        carId:selected_car._id,
        status:'pending',
        bookingType:'car',
        userId:account._id,
        totalPrice:(parseFloat(1)*selected_car?.dailyRate)*0.15+(parseFloat(1)*selected_car?.dailyRate),

    })
    //for currency formating
  
    //handel form change
    const onHandelFormChange=(e)=>{
        if(e.target.name=="durationDays"){
            setForm((prev)=>({
                ...prev,
                totalPrice: (parseFloat(e.target.value)*selected_car?.dailyRate)*0.15+(parseFloat(e.target.value)*selected_car?.dailyRate)

            })) 
        }
        setForm((prev)=>({
            ...prev,
            [e.target.name]:e.target.value
        })) }
        // handel pickup date input filed
        const onHandelPickupChange=(value)=>{
            setForm((prev)=>({
                ...prev,
                startDate:moment(value).local().format('YYYY-MM-DD')
            }))
        }
        //on handel submition of booking
        const handelSubmit =async(e)=>{
            setLoading(true);
            e.preventDefault()
            try {
                const response=await api.post("/bookings/",formData,{
                    headers: { 'Content-Type': 'application/json' }
                })
               if(response.data.status=="success"){
                showModal.showAlert(response.data.msg,"success","center").then(()=>{
                    navigate("/profile",{state:{active:"carBookings"}});
                })
               }
            } catch (error) {
                console.log(error)
            }finally{
                setLoading(false);
            }
        }
  return (
    
    <div className='bg-light container-fluid py-2 px-2 mt-2'>
        {loading && <SimpleBackdrop/>}
            <div className='row mt-5 p-5'>
                <div className='col-sm-12  shadow  border bg-white rounded py-5 px-3 px-md-5 col-md-7 mx-auto'>
                <h6  className='text-start text-secondary h5'>Information</h6>
                <hr className='my-3'/>
                <div>
                    <form onSubmit={handelSubmit}>
                        <div className='row my-3'>
                        <div className='col-sm-12 col-md-6'>
                            {formData?.userType=='Individual'?
                             <label for="Name" className="my-2 text-start w-100 text-secondary fw-bold">Name</label>
                                        :
                                        <label for="Name" className="my-2 text-start w-100 text-secondary fw-bold">Company Name</label>
                                    }
                        <div className="input-group">
                            <span className="input-group-text"><SiNamecheap/> </span>
                            <input disabled type="text" className="form-control py-3" onChange={onHandelFormChange} value={formData.name} placeholder="Name" name='name'/>
                        </div>
                        </div>
                        <div className='col-sm-12 col-md-6'>
                        <label for="email" className="my-2 text-start w-100 text-secondary fw-bold">Email</label>
                        <div className="input-group">
                            <span className="input-group-text"><MdOutlineAlternateEmail/></span>
                            <input type="text" className="form-control py-3" onChange={onHandelFormChange} value={formData.email} placeholder="Email" name='Email'/>
                        </div>
                        </div>
                        </div>
                        <div className='row my-3'>
                        <div className='col-sm-12 col-md-6'>
                        <label for="Phone" className="my-2 text-start w-100 text-secondary fw-bold">Phonenumber</label>
                        <div className="input-group">
                            <span className="input-group-text fw-bold">+251</span>
                            <input type="text" className="form-control py-3" onChange={onHandelFormChange} value={formData.Phonenumber} placeholder="Phonenumber" name="Phonenumber"/>
                        </div>
                        </div>
                        <div className='col-sm-12 col-md-6'>
                        <label for="Driver" className="my-2 text-start w-100 text-secondary fw-bold">Driver</label>
                        <div className="input-group">
                            <span className="input-group-text "><BsPersonCircle/></span>
                            <select class="form-select py-3" onChange={onHandelFormChange} value={formData.driver} name="driver">
                            <option disabled value=''></option>
                            <option selected value='withDriver'>With Driver</option>
                            <option disabled value='withOutDriver'>With Out Driver</option>
                            </select>
                        </div>
                        </div>
                        </div>
                        <div className='row my-3'>
                        <div className='col-sm-12 col-md-6'>
                        <label for="email" className="my-2 text-start w-100 text-secondary fw-bold">When do you want it</label>
                        <div className="input-group">
                            <span className="input-group-text"><IoIosTime /></span>
                        <MobileDatePicker defaultValue={moment()} onChange={(newValue)=>onHandelPickupChange(newValue)} className='form-control p-0' name="start date" minDate={moment()} format='LL'/>
                           
                        </div>
                        </div>
                        <div className='col-sm-12 col-md-6'>
                        <label for="email" className="my-2 text-start w-100 text-secondary fw-bold">For how many days?</label>
                        <div className="input-group">
                            <span className="input-group-text"><FaCalendarDay/></span>
                            <input type="number" min={1}  onChange={onHandelFormChange} value={formData.durationDays} className="form-control py-3" name='durationDays' placeholder="Number of rent days"/>
                        </div>
                        </div>
                        </div>
                            <div className="d-grid px-4 mt-5">
                                <button  type='submit' className='btn btn-outline-primary fw-bold btn-block'>Book</button>
                            </div>

                    </form>
                </div>
                </div>
                <div className='col-sm-12  col-md-4 mx-auto rounded   p-2'>
                
                <div className='container-fluid bg-white shadow border rounded  p-0'>
                    <div className='w-100'>
                    <h6  className='text-center text-secondary h5 my-3 fw-bold'>Your Booking</h6>
                    </div>
                        <div className='d-flex p-3 border-bottom'>
                        <div className='col-5  p-1 '>
                            <img src={`http://localhost:8000${selected_car ?.mainImage}`} alt='' className='w-100 rounded' style={{objectFit:"contain", height:"120px"}}/>
                        </div>
                        <div className='col-7 p-2 d-flex flex-column'>
                            <h6 className='fw-bold text-start mb-3'>{selected_car ?.name}</h6>
                            <h6 className='small text-secondary text-start '>Transition type : {selected_car ?.transmission} </h6>
                            <h6 className='small text-secondary text-start '> Passenger Capacity :  {selected_car ?.carryCapacity.passengers} </h6>
                            <h6 className='small text-secondary text-start '> Bags Capacity :  {selected_car ?.carryCapacity.bags} </h6>
                            <h6 className='small text-secondary text-start '>Model: {selected_car.model} </h6>
                            <h6  className=" small text-secondary text-start">Daily Rate: <span className='text-success fw-bold px-2'>{nf.format(selected_car ?.dailyRate)}</span></h6>

                        </div>
                        </div>
                        <div className="my-4 d-flex flex-column">
                            <div className='d-flex justify-content-around align-items-start my-2 border-bottom'>
                                <div className=''> <FaCalendarDay className='text-secondary'/><span className='mx-2 text-secondary'>No Days</span></div>
                                <div> <span className='mx-2 text-secondary fw-bold'>{formData.durationDays}</span></div>
                            </div>
                            <div className='d-flex justify-content-around align-items-start my-2 border-bottom'>
                                <div className=''> <IoIosTime className='text-secondary'/><span className='mx-2 text-secondary'>Pickup Date </span></div>
                                <div> <span className='mx-2 text-secondary fw-bold'>{moment(formData.startDate).format('DD-MMM-YYYY')}</span></div>
                            </div>
                            <div className='d-flex justify-content-around align-items-start my-2 border-bottom'>
                                <div className=''> <IoIosPricetag className='text-secondary'/><span className='mx-2 text-secondary'>Price</span></div>
                                <div> <span className='mx-2 text-success fw-bold px-2'>{nf.format(parseFloat(formData.durationDays)*selected_car?.dailyRate)}</span></div>
                            </div>
                            <div className='d-flex justify-content-around align-items-start my-2 border-bottom'>
                                <div className=''> <FaPercent className='text-secondary'/><span className='mx-2 text-secondary'>VAT 15%</span></div>
                                <div> <span className='mx-2 text-success fw-bold px-2'>{nf.format((parseFloat(formData.durationDays)*selected_car?.dailyRate)*0.15)}</span></div>
                            </div>
                            <div className='d-flex justify-content-around align-items-start my-2 border-bottom'>
                                <div className=''> <FaMoneyBill className='text-secondary'/><span className='mx-2 text-secondary'>Total Price</span></div>
                                <div> <span className='mx-2 text-success fw-bold px-2'>{nf.format((parseFloat(formData.durationDays)*selected_car?.dailyRate)*0.15+(parseFloat(formData.durationDays)*selected_car?.dailyRate))}</span></div>
                            </div>
                            
                        </div>
                    </div>
                        
                
                </div>
                

            </div>
    </div>
  )
}

export default Bookingpage